module.exports = __webpack_public_path__ + "7bceb5e8e26094f6145283bafe1154bc.svg";